export class TokenInfoModel {
    public tokenType: string = '';

    public accessToken: string = '';

    public expiresIn: number = 0;

    public refreshToken: string = '';

    public refreshTokenExpiresIn: number = 0;
}
